"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateCatalogSupply = void 0;
const react_1 = require("@apollo/client/react");
const create_catalog_supply_mutation_1 = require("./create-catalog-supply.mutation");
const useCreateCatalogSupply = () => {
    const [createCatalogSupply, data] = (0, react_1.useMutation)(create_catalog_supply_mutation_1.CREATE_CATALOG_SUPPLY);
    return Object.assign({ createCatalogSupply }, data);
};
exports.useCreateCatalogSupply = useCreateCatalogSupply;
exports.default = exports.useCreateCatalogSupply;
